import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {FaqCategory} from '../../../../shared/models/api';
import {AppActions} from '../../../actions';

export interface FaqState {
  data: FaqCategory[] | null;
}

const initialState: FaqState = {
  data: null,
};

export const faqSlice = createSlice({
  name: '@@eskso/resources/faq',
  initialState,
  reducers: {
    setFaq: (state, action: PayloadAction<FaqCategory[]>) => {
      state.data = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const faq = faqSlice.reducer;
